module.exports = __webpack_public_path__ + "img/2479.e49eef6b.jpg";